/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ItemTileCarousel_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_viewer" | "ProductCarousel_viewer">;
    readonly " $refType": "ItemTileCarousel_viewer";
};
export type ItemTileCarousel_viewer$data = ItemTileCarousel_viewer;
export type ItemTileCarousel_viewer$key = {
    readonly " $data"?: ItemTileCarousel_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileCarousel_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTileBase_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '18f20385120e19054516a2c6e81a27ed';
export default node;
